/* src/app/modules/display/components/error/orientation-error/orientation-error.component.scss */
.orientation-image {
  height: 10rem;
}
.move-to-top-of-z-stack {
  z-index: 999998;
}
/*# sourceMappingURL=orientation-error.component.css.map */
